"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.navbarMain = void 0;
require("../scss/main.scss");
var NavbarMain_1 = __importDefault(require("./components/NavbarMain"));
var AnimatePaths_1 = __importDefault(require("./utils/AnimatePaths"));
var PageIntro_1 = __importDefault(require("./components/PageIntro"));
var HoverInViewport_1 = __importDefault(require("./utils/HoverInViewport"));
var _accordion_1 = __importDefault(require("./components/_accordion"));
var _set_initial_height_1 = __importDefault(require("./components/_set-initial-height"));
var ProcessTransition_1 = __importDefault(require("./components/ProcessTransition"));
var BlackElement_1 = __importDefault(require("./components/BlackElement"));
var _sticky_lead_button_1 = __importDefault(require("./components/_sticky-lead-button"));
var lastvisited_1 = __importDefault(require("./services/lastvisited"));
var _contact_scroll_1 = __importDefault(require("./components/_contact-scroll"));
document.addEventListener('DOMContentLoaded', function () {
    exports.navbarMain = new NavbarMain_1.default();
    new PageIntro_1.default();
    new AnimatePaths_1.default();
    new HoverInViewport_1.default();
    new _accordion_1.default();
    new _set_initial_height_1.default();
    new ProcessTransition_1.default();
    new BlackElement_1.default();
    new _sticky_lead_button_1.default();
    new lastvisited_1.default();
    new _contact_scroll_1.default();
});
